import { Reset, Theme } from "@bluframe/blublocks"
import styled from "styled-components"

export const Ul = styled(Reset.Ul)`
  background: ${({ theme }: { theme: Theme }) => theme.palette.text.contrast};
  max-height: 220px;
  overflow-y: auto;
`
